import { useContext } from 'react';
import { TimelineContext, TimelineContextValue } from '@/contexts/timelineContexts';

export function useTimelineContext(): TimelineContextValue {
  const context = useContext(TimelineContext);

  if (!context) {
    throw new Error('useTimelineContext must be used within a TimelineContext provider');
  }

  return context;
}
